// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-queue/orders-queue.less
// module id = 3769
// module chunks = 0